var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHandEye = function SvgIconHandEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 18.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 12.125c-1.838 0-3.039.821-3.76 1.662a5.1 5.1 0 0 0-.89 1.505 3 3 0 0 0-.054.16l-.005.013-.001.006v.002l-.001.001.961.276-.962-.275a1 1 0 0 0 1.921.558l.002-.004q.003-.012.016-.047a3.12 3.12 0 0 1 .532-.894c.167-.194.38-.392.652-.557l4.38 1.503a1 1 0 0 0 1.92-.559l-.961.275c.962-.275.961-.275.961-.276v-.003l-.002-.006-.005-.014a2 2 0 0 0-.053-.159 5.12 5.12 0 0 0-.891-1.506c-.721-.84-1.922-1.661-3.76-1.661m-1.589 2.406c.39-.236.906-.406 1.589-.406 1.162 0 1.836.491 2.24.963a3.1 3.1 0 0 1 .533.894l.017.047v.003z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.75 7.761V4.875a2.875 2.875 0 0 0-3.99-2.65 2.875 2.875 0 0 0-5.51 1.15v.261A2.874 2.874 0 0 0 3.5 6.375v7.875a8.5 8.5 0 0 0 17 0V10.5a2.875 2.875 0 0 0-3.75-2.739M10.125 2.5a.875.875 0 0 0-.875.875V10.5a1 1 0 1 1-2 0V6.375a.875.875 0 0 0-1.75 0v7.875a6.5 6.5 0 0 0 13 0V10.5a.875.875 0 0 0-1.75 0v.375a1 1 0 1 1-2 0v-6a.875.875 0 0 0-1.75 0V9.75a1 1 0 1 1-2 0V3.375a.875.875 0 0 0-.875-.875",
    clipRule: "evenodd"
  }))));
};
export default SvgIconHandEye;